import { render, staticRenderFns } from "./CInputTag.vue?vue&type=template&id=14f89ab6&scoped=true&"
import script from "./CInputTag.vue?vue&type=script&lang=js&"
export * from "./CInputTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f89ab6",
  null
  
)

export default component.exports